import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as signalR from '@microsoft/signalr';
import { fetchReceiptsByExpense } from '../api/receiptsApi';

const HUB_URL = `${import.meta.env.VITE_API_URL}/hub/liverefresh`;

// One SignalR connection per expense that's open on screen. Not ideal at
// scale but fine for now — the viewJobPage typically shows <20 expenses at
// once and the connection per-row gives us a simple invalidation path.
export default function useReceiptsByExpense(expenseId) {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['receipts', expenseId],
        queryFn: () => fetchReceiptsByExpense(expenseId),
        enabled: expenseId != null,
        retry: false,
    });

    useEffect(() => {
        if (expenseId == null) return undefined;

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(HUB_URL, {
                accessTokenFactory: () =>
                    window.Clerk.session.getToken({ template: 'marginpal-api' }),
            })
            .withAutomaticReconnect()
            .build();

        connection.on('UpdateReceiptTable', () => {
            queryClient.invalidateQueries({ queryKey: ['receipts', expenseId] });
        });

        connection.start().catch(err => console.error('SignalR connection error:', err));

        return () => {
            connection.stop();
        };
    }, [queryClient, expenseId]);

    return query;
}
